import { configureStore } from '@reduxjs/toolkit';
import logger from 'redux-logger';

// @ts-ignore
// import untypedMiddleware from 'untyped-middleware';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

import rootReducer from '../slices';

const persistConfig = {
  key: 'root',
  storage,
  blacklist: [
    'card',
    'template',
    'user',
    'setting',
  ],
};

export type RootState = ReturnType<typeof rootReducer>

const persistedReducer = persistReducer(persistConfig, rootReducer);

const storeConfig = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .prepend(
        // correctly typed middlewares can just be used
        // additionalMiddleware,
        // you can also type middlewares manually
        // untypedMiddleware as Middleware<
        //   (action: Action<'specialAction'>) => number,
        //   RootState
        // >
      )
      // prepend and concat calls can be chained
      .concat(logger),
  // middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
  devTools: process.env.NODE_ENV !== 'production',
});

// export type RootState = ReturnType<typeof store.getState>

export type AppDispatch = typeof storeConfig.dispatch

const createStore = () => {
  const persistor = persistStore(storeConfig as any);

  if (process.env.NODE_ENV !== 'production' && module.hot) {
    module.hot.accept('../slices', () => {
      // This fetch the new state of the above reducers.
      storeConfig.replaceReducer(
        persistReducer(persistConfig, rootReducer),
      );
    });
  }

  return { store: storeConfig, persistor };
};

export const { store, persistor } = createStore();

// export { store: ss, persistor };
